<template>
    <div>
    <div class="air__utils__heading">
      <h5>Boekhouding</h5>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-6">
        <div class="card">

          <div class="card-body">
            <a-tabs v-model="tabNumber" defaultActiveKey="1" class="air-tabs-bordered">
              <a-tab-pane tab="Periodieke Omzet" key="1" v-if="$auth.check('admin')" />
              <a-tab-pane tab="RPS CSV Export" key="2" v-if="$auth.check('admin')" />
              <a-tab-pane tab="Mollie CSV Import" key="3" v-if="$auth.check('admin')" />
              <a-tab-pane tab="Camt" key="4" v-if="$auth.check('admin')" />
            </a-tabs>
            <div v-if="tabNumber == '1'">
              <revenue-component />
            </div>
            <div v-if="tabNumber == '2'">
              <yuki-csv-export-component />
            </div>
            <div v-if="tabNumber == '3'">
              <mollie-payout-import-component />
            </div>
            <div v-if="tabNumber == '4'">
              <camt />
            </div>
          </div>
        </div>

      </div>
      <div class="col-xl-4 col-lg-6">

      </div>
    </div>
  </div>
</template>
<script>
import RevenueComponent from '@/components/widgets/Bookkeeping/RevenueComponent'
import YukiCsvExportComponent from '@/components/widgets/Bookkeeping/YukiCsvExportComponent'
import MolliePayoutImportComponent from '@/components/widgets/Bookkeeping/MolliePayoutImportComponent'
import Camt from '@/components/widgets/Bookkeeping/Camt'
// import moment from 'moment'
export default {
  data() {
    return {
      tabNumber: '1',
    }
  },
  components: {
    RevenueComponent,
    YukiCsvExportComponent,
    MolliePayoutImportComponent,
    Camt,
  },
}
</script>
